<template>
  <v-lazy>
    <apexchart type="bar" height="200" :options="chartOptions" :series="series"></apexchart>
  </v-lazy>
</template>

<script>
export default {
  data() {
    return {
      series: [
        {
          name: "Óbitos",
          data: this.patientDeathsData
        },
        {
          name: "Recuperados",
          data: this.patientsRecoveredData
        }
      ],
      chartOptions: {
        chart: {
          type: "bar",
          toolbar: {
            show: false
          },
          fontFamily: "Montserrat, sans-serif"
        },
        colors: ["#B7000C", "#0012A6"],
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: "rounded",
            distributed: false,
            columnWidth: "25px"
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: "right",
          horizontalAlign: "right",
          floating: false,
          fontSize: "12px",
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 400,
          formatter: function(seriesName, opts) {
            const globalSeriesArrayClone = [
              new Array(...opts.w.globals.series[0]),
              new Array(...opts.w.globals.series[1])
            ];
            globalSeriesArrayClone[0].forEach((item, index) => {
              if (item === 0 && globalSeriesArrayClone[1][index] === 0) {
                globalSeriesArrayClone[0].splice(index);
                globalSeriesArrayClone[1].splice(index);
              }
            });
            const deathsAndSavedNumbersArray = globalSeriesArrayClone[opts.seriesIndex];
            const deathsAndSavedNumbersValue = deathsAndSavedNumbersArray.reduce(
              (sum, el) => sum + el, 0
            ) / deathsAndSavedNumbersArray.length;
            
            return [
              `
							${isNaN(deathsAndSavedNumbersValue) ? '' : deathsAndSavedNumbersValue}%
							`,
              seriesName
            ];
          },
          inverseOrder: true,
          width: undefined,
          height: undefined,
          tooltipHoverFormatter: undefined,
          offsetX: -12,
          offsetY: 40,
          labels: {
            colors: ["#B7000C", "#0012A6"],
            useSeriesColors: true
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: undefined,
            fillColors: undefined,
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0
          },
          itemMargin: {
            horizontal: 5,
            vertical: 2
          },
          onItemClick: {
            toggleDataSeries: false
          },
          onItemHover: {
            highlightDataSeries: true
          }
        },
        stroke: {
          show: false,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: this.categories,
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        },
        yaxis: {
          showAlways: true,
          min: 0,
          max: 100,
          tickAmount: 2
        },
        fill: {
          opacity: 1
        }
      }
    };
  },
  computed: {
    filteredPatientRecoveredArray() {
      const array = new Array([...this.patientsRecoveredData]);
      this.patientsRecoveredData.forEach((item, index) => {
        if (item === 0)
          if (this.patientDeathsData[index] === 0) delete array[index];
      });
      return array;
    },
    filteredPatientDeathsArray() {
      const array = new Array([...this.patientDeathsData]);
      this.patientsDeathsData.forEach((item, index) => {
        if (item === 0)
          if (this.patientRecoveredData[index] === 0) delete array[index];
      });
      return array;
    }
  },
  props: {
    patientsRecoveredData: {
      type: Array,
      required: true
    },
    patientDeathsData: {
      type: Array,
      required: true
    },
    categories: {
      type: Array,
      required: true
    }
  }
};
</script>